import * as React from 'react';
import { TiptapButton } from '../../TiptapButton';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTable } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';

export const InsertTableButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() =>
            editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: false }).run()
         }
         isDisabled={
            editor.isActive('table') ||
            !editor.can().insertTable({ rows: 3, cols: 3, withHeaderRow: false })
         }
         icon={<FontAwesomeIcon icon={faTable} />}
         title={_js('Insert Table')}
      ></TiptapButton>
   );
};
